import React from "react";
import ButtonNew from "common/Button/Button"
import { useTranslation } from "react-i18next";
import { ReactComponent as BackBtn } from "../../assets/Modal/arrowBack.svg"
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
interface DynamicDiv {
    heading: string;
    value: string;
}
interface ComponentSubheaderProps {
    showBtn?: boolean;
    onClick?: () => void;
    onSubmit?: () => void;
    heading?: string;
    subHeading1?: string;
    subHeading2?: string;
    icon?: React.ReactNode;
    mainImg?: React.ReactNode;
    dynamicDivs?: DynamicDiv[];
    showDetails?: boolean;
    btnText?: string;
    btnType?: string;
    showSaveBtn?: boolean;
    isBtnEnabled?: boolean;
    showCreateBtn?: boolean;
}
const ComponentSubheader: React.FC<ComponentSubheaderProps> = ({
    showBtn = false,
    onClick = () => { },
    onSubmit = () => { },
    heading,
    icon,
    mainImg,
    subHeading1,
    subHeading2,
    dynamicDivs = [],
    showDetails,
    btnText,
    btnType,
    showSaveBtn,
    isBtnEnabled,
    showCreateBtn
}) => {
    const params = useParams();
    const { t } = useTranslation();
    return (
        <Box
            className={`top-[140px] z-[19] flex bg-white justify-between items-center rounded-lg py-1 px-5 text-black`}
            style={{
                minHeight: showDetails ? "100px" : "72px",
            }}
        >
            <Box style={{ display: "flex" }}>
                <span style={{ marginRight: "0px" }}>{mainImg}</span>
                <Box style={{ display: showDetails ? '' : "flex" }}>
                    <Box style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                        <Box className="mr-1">
                            {!showBtn ? <span className='bg-unselected-color h-[38px] cursor-pointer rounded-[10px] mr-2 w-[38px] flex text-center items-center justify-center' onClick={onClick}>{<BackBtn />}</span> : <span className=' lex text-center items-center justify-center'>{icon}</span>}
                        </Box>
                        <h1 className="mt-1 font-Saira font-bold text-lg ml-1 line-clamp-1" >{heading && t(heading)}</h1>
                    </Box>
                    <h1 className="float-left font-Saira font-bold text-sm mt-1	">{subHeading1 && t(subHeading1)}</h1>
                    <br />
                    <h1 className="float-left font-Saira font-semibold text-sm italic	">{subHeading2 && t(subHeading2)}</h1>
                </Box>
            </Box>

            <Box style={{ display: "flex" }}>
                {dynamicDivs.map((div, index) => (
                    <div key={index} className="border-r border-white border-solid p-[6px]" >
                        <h1 className="text-white font-Saira font-[500] text-sm">{div.heading}</h1>
                        <h1 className="text-white font-Saira font-bold text-[15px]">{div.value}</h1>
                    </div>
                ))}
            </Box>
            <Box className="flex pl-3">
                {showBtn && (
                    <Box style={{ marginLeft: "10px" }}>
                        {showCreateBtn && btnType === 'create' ?
                            <ButtonNew
                                onClick={onClick}
                                type={btnType}
                                disabled={false}
                                text={btnText}
                                hasIcon
                            ></ButtonNew>
                            : !showCreateBtn && btnType === 'create' ? null
                                : <ButtonNew
                                    onClick={onClick}
                                    type={btnType}
                                    disabled={false}
                                    text={btnText}
                                    hasIcon
                                ></ButtonNew>
                        }
                    </Box>
                )}
                {showSaveBtn && (
                    <Box style={{ marginLeft: "10px" }}>
                        <ButtonNew
                            onClick={onSubmit}
                            type={!isBtnEnabled ? "disabled" : "create"}
                            disabled={!isBtnEnabled}
                            text={params?.ifid || params?.isid || params?.driverId 
                                || params?.clid || params?.clid || params?.policyId
                                ? "update" : "submit"}
                            hasIcon
                        ></ButtonNew>
                    </Box>
                )}
            </Box>
        </Box>
    );
};
export default ComponentSubheader;